export default {
      id: "recruitment-evaluation-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#recruitment-evaluation-usage",
      toString: function () {
        return this.url;
      }
    }